import { IAddress } from "@wingspanhq/users/dist/lib/interfaces";
import { selectorAddressString } from "../../../shared/selectors/selectorAddressString";

/**
 * Formats a resolved prefill value for read-only display. Addresses arrive as
 * objects and are formatted the way the read-only PII card did; any other object
 * shape falls back to a plain value join. Empty values render as an em dash.
 */
export const formatReadOnlyValue = (val: unknown): string => {
  if (val == null || val === "") return "—";
  if (typeof val === "object") {
    return (
      selectorAddressString(val as Partial<IAddress>, false, ", ") ||
      Object.values(val as Record<string, unknown>)
        .filter(Boolean)
        .join(", ")
    );
  }
  return String(val);
};
